import { Action, createReducer, on } from '@ngrx/store';
import * as CrossSellingActions from './cross-selling.actions';
import { initialState, CrossSellingState } from './cross-selling.state';

const crossSellingReducer = createReducer(
  initialState,
  on(
    CrossSellingActions.patchQuestions,
    (state, action: ReturnType<typeof CrossSellingActions.patchQuestions>) => ({
      ...state,
      CrossSelling: { ...state.CrossSelling, ...action.payload }
    })
  ),
  on(CrossSellingActions.init, state => ({
    ...state,
    ...initialState
  }))
);

export function reducer(state: CrossSellingState | undefined, action: Action) {
  return crossSellingReducer(state, action);
}
